export default "__VITE_ASSET__D229lB3B__"